module.exports = __webpack_public_path__ + "static/media/jcdecaux.18a59e26.png";